import React, { useCallback, useMemo } from 'react'
import cx from 'classnames'
import { any, arrayOf, func, node, number, objectOf, string } from 'prop-types'

import SearchField from '../searchfield/searchfield'
import IconSelect from '../select/icon-select'
import Option from '../select/option'
import { compareStringsWithLeftTrimAndLowerCase } from './assignment-editor-helper'

import styles from './assignment-editor-list.module.css'

const propTypes = {
    allItemIds: arrayOf(number).isRequired,
    filterBarClassName: string,
    filterGroup: string,
    filterText: string,
    groups: arrayOf(objectOf(any)),
    groupsFilterClassName: string,
    groupsFilterIcon: node,
    groupsPlaceholder: string,
    onChangeFilterText: func,
    onChangeGroup: func,
    placeholder: string,
    searchFilterClassName: string
}

const defaultProps = {
    groups: [],
    onChangeFilterText: () => null,
    onChangeGroup: () => null
}

const AssignmentEditorListFilter = ({
    allItemIds,
    filterBarClassName,
    filterGroup,
    filterText,
    groups,
    groupsFilterClassName,
    groupsFilterIcon,
    groupsPlaceholder,
    onChangeFilterText,
    onChangeGroup,
    placeholder,
    searchFilterClassName
}) => {
    const barClassName = cx(styles['filter-bar'], filterBarClassName)

    const handleOnChangeGroup = useCallback(
        event => {
            onChangeGroup(event?.target?.value || null)
        },
        [onChangeGroup]
    )

    const renderedGroups = useMemo(() => {
        const sortedGroups = groups.sort((group1, group2) =>
            compareStringsWithLeftTrimAndLowerCase(group1.name, group2.name)
        )

        const options = [{ id: 0, items: null, name: groupsPlaceholder }].concat(sortedGroups)
        const selectwrapperClassName = cx(styles['select-wrapper'], groupsFilterClassName)

        const getGroupFilteredItemCount = (items = []) => items.filter(item => allItemIds.includes(item.id)).length

        const groupsElement = options.map(group => {
            const groupItemSizeElement = group.items ? (
                <div className={styles['filter-group-size']}>({getGroupFilteredItemCount(group.items)})</div>
            ) : null

            return (
                <Option key={group.id} value={group.id}>
                    <div className={styles['filter-group-text']}>
                        {groupItemSizeElement}
                        <div className={styles['filter-group-name']}>{group.name}</div>
                    </div>
                </Option>
            )
        })

        return (
            <div className={selectwrapperClassName}>
                <IconSelect
                    icon={groupsFilterIcon}
                    onChange={handleOnChangeGroup}
                    value={filterGroup}
                    className="t3sel-assignment-editor-list-group-select"
                >
                    {groupsElement}
                </IconSelect>
            </div>
        )
    }, [
        groups,
        allItemIds,
        filterGroup,
        groupsFilterClassName,
        groupsPlaceholder,
        groupsFilterIcon,
        handleOnChangeGroup
    ])

    const handleOnChangeFilterText = useCallback(
        value => {
            onChangeFilterText(value || '')
        },
        [onChangeFilterText]
    )

    return (
        <div className={barClassName}>
            <SearchField
                className="t3sel-filterable-list-filter"
                value={filterText}
                onChange={handleOnChangeFilterText}
                containerClassName={cx(
                    {
                        [styles['textfield']]: groups.length
                    },
                    searchFilterClassName,
                    't3sel-assignment-editor-input'
                )}
                {...{ placeholder }}
            />
            {!!groups.length && renderedGroups}
        </div>
    )
}

AssignmentEditorListFilter.propTypes = propTypes
AssignmentEditorListFilter.defaultProps = defaultProps

export { AssignmentEditorListFilter }
